export default __webpack_public_path__ + "static/media/google.9aefd664.svg";